<template>
  <div class="testMain" style="background: #2d3136">
    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #2d3136;
        color: #fff;
        padding: 10px 10px;
      "
      class="hok_label">
      <div
        style="
          display: flex;
          align-items: center;
        "
      >
        <span class="current_img"><img :src="skin_icon" /></span>
        <div class="ms-2">
          <div>{{ hero_name + "-" + skin_name + getSelectedSkinGender }}</div>
        </div>
      </div>
      <div>
        <el-form :inline="true" size="mini">
          <el-form-item label="选择英雄">
            <el-select
              @change="onHeroChange"
              filterable
              v-model="hero_id"
            >
              <el-option
                v-for="item in hokIcon?.hero_list"
                :key="item.hero_id"
                :label="item.hero_name"
                :value="item.hero_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择皮肤">
            <el-select v-model="skin_name" @change="onSkinNameChange">
              <el-option
                v-for="item in curSkinNames"
                :key="item.skin_name"
                :label="`${item.skin_name}`"
                :value="item.skin_name + ''"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="选择性别">
            <el-select v-model="curSkin" size="mini" placeholder="">
              <el-option v-for="item of curSkins" :key="item" :label="genderOptions[item.gender]" :value="`${item.skin_id}&${item.gender}`" />
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="mini" @click="confirm()">确定</el-button>
            <el-button type="primary" size="mini" @click="openBatchGenerateSkins">查看批量皮肤</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="spacName">
      <h5 style="color: #fff"><span></span>局内皮肤性能数据</h5>
      <el-table
        class="my-table-hok_v1"
        :span-method="mergeCells1"
        size="mini"
        :header-cell-style="{
          background: '#42484E',
          color: '#fff',
        }"
        element-loading-background="#42484E"
        :data="hok_inside_table"
      >
        <el-table-column width="130" label="机型">
          <template #default="scope">
            {{ scope.row.model }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="画质">
          <template #default="scope">
            <span>
              {{ scope.row.data.quality }}
            </span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="标准">
          <template #default="scope">
            <span>
              {{ "≥" + scope.row.data.baseline }}
            </span>
          </template>
        </el-table-column> -->
        <el-table-column width="210" label="版本日期">
          <template #default="scope">
            <span
              :style="
                'margin-left:' +
                (scope.row.data.level == 0 ? '0px' : '10px')
              "
            >
              {{ scope.row.data.date
              }}<i
                style="cursor: pointer"
                v-if="scope.row.data.level == 0 && scope.row.show"
                @click="expandCheck(scope.row)"
                :class="
                  scope.row.check
                    ? 'el-icon-arrow-down'
                    : 'el-icon-arrow-up'
                "
              ></i>
            </span>
            <span
              @click="expandCheckAdd(scope.row)"
              style="color: #70c1f1; cursor: pointer"
              v-if="scope.row.many"
              >(查看更多)</span
            >
          </template>
        </el-table-column>
        <el-table-column label="分支">
          <template #default="scope">
            <span> {{ scope.row.data.custom_version }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column label="svn">
          <template #default="scope">
            <span>{{ scope.row.data.svn }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="结论">
          <template #default="scope">
            <span>{{ scope.row.data.result }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in in_data"
          :key="item.value"
          :label="item.name"
        >
          <el-table-column label="标准">
            <template #default="scope">
              <span>{{ scope.row.data.standard?.[item.value] || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数值">
            <template #default="scope">
              <span
                :style="
                  'color:' + (scope.row.data.color?.[item.value] || '')
                "
                >{{ scope.row.data[item.value] || '-' }}</span
              >
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="链接">
          <template #default="scope">
            <span>
              <a
                target="_blank"
                style="cursor: pointer; color: #70c1f1"
                :href="scope.row.data.url"
                >查看</a
              >
            </span>
          </template>
        </el-table-column>

        <!-- <el-table-column label="Perfdog">
          <template #default="scope">
            <a
              v-if="scope.row.data.link"
              target="_blank"
              style="cursor: pointer; color: #70c1f1"
              :href="scope.row.data.link">查看</a>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column label="adb报错" #default="{row}" align="center">
          {{ getAdbCount(row) }}
        </el-table-column>

        <el-table-column label="adb下载" #default="{row}" align="center">
          <a v-if="row?.data?.adb?.filepath" :href="row?.data?.adb?.filepath" target="_blank" download>日志文件</a>
          <span v-else>-</span>
        </el-table-column> -->

        <el-table-column label="删除" #default="{row}">
          <el-popconfirm
            @confirm="deleteRow(row)"
            placement="top"
            title="确认删除该条数据？"
          >
            <template #reference>
              <el-button type="text" size="mini">删除</el-button>
            </template>
          </el-popconfirm>
        </el-table-column>
      </el-table>
    </div>

    <div class="spacName">
      <h5 style="color: #fff"><span></span>局外皮肤性能数据</h5>

      <el-table
        class="my-table-hok_v1"
        size="mini"
        :header-cell-style="{
          background: '#42484E',
          color: '#fff',
        }"
        element-loading-background="#42484E"
        :data="hok_out_table"
        :span-method="mergeCells"
      >
        <el-table-column width="130" label="机型">
          <template #default="scope">
            {{ scope.row.model }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="画质">
          <template #default="scope">
            <span>
              {{ scope.row.data.quality }}
            </span>
          </template>
        </el-table-column> -->

        <el-table-column label="动作" prop="action">
          <template #default="scope">
            <span style="color: #70c1f1">
              {{ getActionText(scope.row.action) }}
            </span>
          </template>
        </el-table-column>

        <el-table-column width="210" label="版本日期">
          <template #default="scope">
            <span
              :style="
                'margin-left:' +
                (scope.row.data.level == 0 ? '0px' : '10px')
              "
            >
              {{ scope.row.data.date
              }}<i
                style="cursor: pointer"
                v-if="scope.row.data.level == 0 && scope.row.show"
                @click="expandCheckOut(scope.row)"
                :class="
                  scope.row.check
                    ? 'el-icon-arrow-down'
                    : 'el-icon-arrow-up'
                "
              ></i>
            </span>
            <span
              @click="expandCheckOutAdd(scope.row)"
              style="color: #70c1f1; cursor: pointer"
              v-if="scope.row.many"
              >(查看更多)</span
            >
          </template>
        </el-table-column>
        <el-table-column label="分支">
          <template #default="scope">
            <span>
              {{ scope.row.data.custom_version }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="svn">
          <template #default="scope">
            <span>{{ scope.row.data.svn }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="结论">
          <template #default="scope">
            <span>{{ scope.row.data.result }}</span>
          </template>
        </el-table-column>

        <el-table-column
          v-for="item in out_data"
          :key="item.value"
          :label="item.name"
        >
          <el-table-column label="标准">
            <template #default="scope">
              <span>{{ scope.row.data.standard?.[item.value] || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数值">
            <template #default="scope">
              <span
                :style="
                  'color:' + (scope.row.data.color?.[item.value] || '')
                "
                >{{ scope.row.data[item.value] || '-' }}</span
              >
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="内存峰值增量" prop="max_pss_add" #default="{row}">
          {{ row.data.max_pss_add ? `${row.data.max_pss_add?.toFixed(2)}M` : '--' }}
        </el-table-column>
        <el-table-column label="内存均值增量" prop="avg_pss_add" #default="{row}">
          {{ row.data.avg_pss_add ? `${row.data.avg_pss_add?.toFixed(2)}M` : '--' }}
        </el-table-column>

        <el-table-column label="链接">
          <template #default="scope">
            <span>
              <a
                target="_blank"
                style="cursor: pointer; color: #70c1f1"
                :href="scope.row.data.url"
                >查看</a
              >
            </span>
          </template>
        </el-table-column>

        <!-- <el-table-column label="Perfdog">
          <template #default="scope">
            <a
              v-if="scope.row.data.link"
              target="_blank"
              style="cursor: pointer; color: #70c1f1"
              :href="scope.row.data.link">查看</a>
            <span v-else>--</span>
          </template>
        </el-table-column> -->

        <el-table-column label="删除" #default="{row}">
          <el-popconfirm
            @confirm="deleteRow(row, true)"
            placement="top"
            title="确认删除该条数据？"
          >
            <template #reference>
              <el-button type="text" size="mini">删除</el-button>
            </template>
          </el-popconfirm>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {ref, computed, watch} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import axios from 'axios'
import { ElMessage } from "element-plus"

function useInsideTable(skin_id, curSkinGender) {
  function mergeCells1({row, rowIndex, columnIndex}) {
    if (columnIndex !== 0) return
    const table = hok_inside_table.value
    // 上一行是同机型 → 本行已被上一行的 rowspan 覆盖
    if (rowIndex > 0 && table[rowIndex - 1]?.model === row.model) {
      return { rowspan: 0, colspan: 0 }
    }
    // 只统计「连续」的同机型行数，避免非连续时 rowspan 错位
    let rowCount = 1
    for (let i = rowIndex + 1; i < table.length; i++) {
      if (table[i]?.model === row.model) rowCount++
      else break
    }
    return rowCount > 1 ? { rowspan: rowCount, colspan: 1 } : undefined
  }

  function expandCheck(data) {
    data.check = !data.check;
    
    if (!data.check) {
      let list = [];
      let addData = hokinData.value?.[data.model].filter((v) => v.level != 0);

      addData.forEach((v) => {
        list.push({
          model: data.model,
          data: v,
        });
      });
      let index = hok_inside_table.value.findIndex(
        (v) => v.model == data.model && v.data.id_test == data.data.id_test
      );
      if (index !== -1) {
        // 确保找到了索引
        hok_inside_table.value.splice(index + 1, 0, ...list);
      }
    } else {
      // 展开时插入的是所有 level != 0 的行，收起时同样要全部移除，避免残留
      hok_inside_table.value = hok_inside_table.value.filter(
        (item) => !(item.model === data.model && item.data.level !== 0)
      );
    }
    let occurrenceCount = {};
    let lastOccurrence = {};
    hok_inside_table.value.forEach((device, index) => {
      let model = device.model;
      if (!occurrenceCount[model]) {
        occurrenceCount[model] = 0;
      }
      occurrenceCount[model]++;
      lastOccurrence[model] = index;
    })

    //Second pass to set the 'many' field
    hok_inside_table.value.forEach((device, index) => {
      let model = device.model;
      if (occurrenceCount[model] > 1) {
        device.many = index === lastOccurrence[model];
      } else {
        device.many = false;
      }
    })
  }

  function insertAfterLastOccurrence(model, newDevice) {
    // Find the last occurrence of the given model
    let lastIndex = -1;
    hokinData.value?.[model].forEach((device, index) => {
      if (device.model === model) {
        lastIndex = index;
      }
    });

    // Insert the new device after the last occurrence
    if (lastIndex !== -1) {
      hokinData.value?.[model].splice(lastIndex + 1, 0, ...newDevice);
    } else {
      // If the model is not found, append the new device at the end
      hokinData.value?.[model].push(...newDevice);
    }
  }

  function insertAfterLastOccurrenceAdd(model, newDevice) {
    // Find the last occurrence of the given model
    let lastIndex = -1;
    hok_inside_table.value.forEach((device, index) => {
      if (device.model === model) {
        lastIndex = index;
      }
    });

    // Insert the new device after the last occurrence
    if (lastIndex !== -1) {
      hok_inside_table.value.splice(lastIndex + 1, 0, ...newDevice);
    } else {
      // If the model is not found, append the new device at the end
      hok_inside_table.value.push(...newDevice);
    }
  }

  async function expandCheckAdd(data) {
    const res = await axios('report/in_skin_data_more_v2/', {
      params: {
        project: 34,
        skin_id: skin_id.value,
        device_name: data.model,
        page: hok_inside_table.value.filter((v) => v.model == data.model).length,
        gender: curSkinGender.value,
        quality: data.quality,
      }
    })
    addHokIn.value = res.data

    if (addHokIn.value.length > 0) {
      let list = []
      addHokIn.value.forEach((v) => {
        list.push({
          model: data.model,
          data: v,
        })
      })
      insertAfterLastOccurrence(data.model, addHokIn.value)
      insertAfterLastOccurrenceAdd(data.model, list)
      let occurrenceCount = {};
      let lastOccurrence = {};
      hok_inside_table.value.forEach((device, index) => {
        let model = device.model;
        if (!occurrenceCount[model]) {
          occurrenceCount[model] = 0;
        }
        occurrenceCount[model]++;
        lastOccurrence[model] = index;
      });

      //Second pass to set the 'many' field
      hok_inside_table.value.forEach((device, index) => {
        let model = device.model;
        if (occurrenceCount[model] > 1) {
          device.many = index === lastOccurrence[model];
        } else {
          device.many = false;
        }
      })
    } else {
      ElMessage.error("暂无更多数据");
    }
  }

  function getAdbCount(row) {
    const count = row?.data?.adb?.error_count
    return (count || count === 0) ? count : '-'
  }

  async function hok_inside_api() {
    const {data} = await axios(`report/in_skin_data_v2/?project=34&skin_id=${skin_id.value}&gender=${curSkinGender.value}`)

    hokinData.value = data || {}
    const table = []
    for (let i in hokinData.value) {
      const list = Array.isArray(hokinData.value[i]) ? hokinData.value[i] : []
      const show = list.length > 1
      list.forEach((v) => {
        // 过滤无效记录，避免渲染出整行空白
        if (!v || v.level != 0 || !(v.date || v.id_test)) return
        table.push({
          model: i,
          // 兜底嵌套对象，防止 standard/color 缺失时取属性报错中断渲染
          data: { ...v, standard: v.standard || {}, color: v.color || {} },
          check: true,
          show,
        })
      })
    }
    // 整体赋值，避免中途出错导致表格停在半填充状态
    hok_inside_table.value = table
  }

  let hokinData = ref([]),
    hok_inside_table = ref([]),
    in_data = ref([
      { name: "平均帧率(高于)", value: "avg_fps" },
      { name: "低帧率占比(低于)", value: "fps_lt_40_pcnt" },
      { name: "最低帧率(高于)", value: "min_fps" },
      { name: "CPU占用率均值(低于)", value: "avg_cpu" },
      { name: "内存峰值(低于)", value: "max_pss" },
      { name: "卡顿率(低于)", value: "caton" },
      { name: "内存均值", value: "avg_pss" },
      { name: "帧率方差(低于)", value: "var_fps" },
    ]),
    addHokIn = ref([])

  return {in_data, hok_inside_table, mergeCells1, expandCheck, expandCheckAdd, getAdbCount, hok_inside_api}
}

function useOutTable(skin_id, curSkinGender) {
  function mergeCells({row, column, rowIndex, columnIndex}) {
    if (columnIndex === 0) {
      const rowCount = hok_out_table.value.filter(
        (item) => item.model === row.model
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          hok_out_table.value.findIndex((item) => item.model === row.model) ===
          rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 1) {
      const rowCount = hok_out_table.value.filter(
        (item) => item.action === row.action && item.model === row.model
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          hok_out_table.value.findIndex(
            (item) => item.action === row.action && item.model === row.model
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
  }

  function getActionText(action) {
    if (action === "进场") {
      return "入场";
    } else if (action === "站定") {
      return "待机";
    }
    return action;
  }

  function expandCheckOut(data) {
    data.check = !data.check;
    if (!data.check) {
      let list = [];
      let addData = hokOutData.value[data.model][data.action].filter(
        (v) => v.level != 0
      )

      addData.forEach((v) => {
        list.push({
          model: data.model,
          action: data.action,
          data: v,
        });
      });
      let index = hok_out_table.value.findIndex(
        (v) =>
          v.model == data.model &&
          v.data.id_test == data.data.id_test &&
          v.action == data.action
      );
      if (index !== -1) {
        //确保找到了索引
        hok_out_table.value.splice(index + 1, 0, ...list)
      }
    } else {
      // 展开时插入的是所有 level != 0 的行，收起时同样要全部移除，避免残留
      hok_out_table.value = hok_out_table.value.filter(
        (item) =>
          !(
            item.model === data.model &&
            item.data.level !== 0 &&
            item.action == data.action
          )
      );
    }
    let occurrenceCount = {}
    let lastOccurrence = {}

    //First pass to count occurrences and find last occurrence index
    hok_out_table.value.forEach((device, index) => {
      let key = `${device.model}_${device.action}`
      if (!occurrenceCount[key]) {
        occurrenceCount[key] = 0
      }
      occurrenceCount[key]++
      lastOccurrence[key] = index
    })

    //Second pass to set the 'many' field
    hok_out_table.value.forEach((device, index) => {
      let key = `${device.model}_${device.action}`
      if (occurrenceCount[key] > 1) {
        device.many = index === lastOccurrence[key]
      } else {
        device.many = false
      }
    })
  }

  function insertAfterLastOccurrenceOut(model, action, newDevice) {
    // Find the last occurrence of the given model
    let lastIndex = -1;
    hokOutData.value[model][action].forEach((device, index) => {
      if (device.model === model && device.action == action) {
        lastIndex = index;
      }
    });

    // Insert the new device after the last occurrence
    if (lastIndex !== -1) {
      hokOutData.value[model][action].splice(lastIndex + 1, 0, ...newDevice);
    } else {
      // If the model is not found, append the new device at the end
      hokOutData.value[model][action].push(...newDevice);
    }
  }

  function insertAfterLastOccurrenceOutAdd(model, action, newDevice) {
    // Find the last occurrence of the given model
    let lastIndex = -1;
    hok_out_table.value.forEach((device, index) => {
      if (device.model === model && device.action == action) {
        lastIndex = index;
      }
    });

    // Insert the new device after the last occurrence
    if (lastIndex !== -1) {
      hok_out_table.value.splice(lastIndex + 1, 0, ...newDevice);
    } else {
      //If the model is not found, append the new device at the end
      hok_out_table.value.push(...newDevice);
    }
  }

  async function expandCheckOutAdd(data) {
    const res = await axios('report/skin_data_more/', {
      params: {
        project: 34,
        skin_id: skin_id.value,
        device_name: data.model,
        page: hok_out_table.value.filter(v => v.model == data.model && v.action == data.action).length,
        action: data.action,
        gender: curSkinGender.value,
        quality: data.quality
      }
    })
    addHokOut.value = res.data

    if (addHokOut.value.length > 0) {
      let list = []
      addHokOut.value.forEach((v) => {
        list.push({
          model: data.model,
          data: v,
          action: data.action,
        })
      })
      insertAfterLastOccurrenceOut(
        data.model,
        data.action,
        addHokOut.value,
      )
      insertAfterLastOccurrenceOutAdd(data.model, data.action, list)
      let occurrenceCount = {}
      let lastOccurrence = {}

      //First pass to count occurrences and find last occurrence index
      hok_out_table.value.forEach((device, index) => {
        let key = `${device.model}_${device.action}`
        if (!occurrenceCount[key]) {
          occurrenceCount[key] = 0
        }
        occurrenceCount[key]++
        lastOccurrence[key] = index
      })

      //Second pass to set the 'many' field
      hok_out_table.value.forEach((device, index) => {
        let key = `${device.model}_${device.action}`
        if (occurrenceCount[key] > 1) {
          device.many = index === lastOccurrence[key]
        } else {
          device.many = false
        }
      });
    } else {
      ElMessage.error("暂无更多数据")
    }
  }

  async function hok_out_api() {
    const {data} = await axios(`report/skin_data_v2/?project=34&skin_id=${skin_id.value}&gender=${curSkinGender.value}`)
    
    hokOutData.value = data || {}
    const table = []
    for (let i in hokOutData.value) {
      for (let n in hokOutData.value[i]) {
        const list = Array.isArray(hokOutData.value[i][n]) ? hokOutData.value[i][n] : []
        const show = list.length > 1
        list.forEach((v) => {
          // 过滤无效记录，避免渲染出整行空白
          if (!v || v.level != 0 || !(v.date || v.id_test)) return
          table.push({
            model: i,
            action: n,
            // 兜底嵌套对象，防止 standard/color 缺失时取属性报错中断渲染
            data: { ...v, standard: v.standard || {}, color: v.color || {} },
            check: true,
            show,
          })
        })
      }
    }
    // 整体赋值，避免中途出错导致表格停在半填充状态
    hok_out_table.value = table
  }

  let hokOutData = ref([]),
    hok_out_table = ref([]),
    out_data = ref([
      { name: "平均帧率(高于)", value: "avg_fps" },
      { name: "最低帧率(高于)", value: "min_fps" },
      { name: "CPU占用率均值(低于)", value: "avg_cpu" },
      { name: "内存峰值(低于)", value: "max_pss" },
      { name: "内存均值", value: "avg_pss" },
    ]),
    addHokOut = ref([])

  return {hok_out_table, out_data, mergeCells, getActionText, expandCheckOut, expandCheckOutAdd, hok_out_api}
}



export default {
  props: {
    hokIcon: Object,
    activeTab: String,
  },

  setup(props) {
    function openBatchGenerateSkins() {
      //使用 $router.resolve 方法获取新页面的 URL
      const routeData = router.resolve({
        path: "/batch_generate_skins",
      })

      // 使用 window.open 在新页面打开 URL
      window.open(routeData.href, "_blank")
    }

    function onHeroChange() {
      skin_name.value = ''
      curSkin.value = ''
    }

    function onSkinNameChange() {
      const firstSkin = curSkins.value?.[0]
      curSkin.value = `${firstSkin?.skin_id}&${firstSkin?.gender}`
    }

    function confirm() {
      hero_name.value = props.hokIcon?.hero_list?.filter(
        (v) => v.hero_id == hero_id.value
      )[0].hero_name;
    
      hok_inside_api()
      hok_out_api()
      router.push({
        query: {
          ...route.query,
          hero_id: hero_id.value,
          skin_id: skin_id.value,
          gender: curSkinGender.value,
          skin_name: skin_name.value,
        },
      })
    }

    async function deleteRow(row, isOut) {
      await axios.put(`performance/skin_performance/`, {
        "id_test": row.data.id_test,
        "is_valid": false,
        "project": 34,
      })
      ElMessage.success('删除成功')
      // setup 中 this 为 undefined，必须直接调用闭包里的函数
      isOut ? hok_out_api() : hok_inside_api()
    }

    function init() {
      hero_id.value = route.query.hero_id
        ? Number(route.query.hero_id)
        : props.hokIcon.hero_list[0].hero_id

      hero_name.value = props.hokIcon?.hero_list?.filter(
        (v) => v.hero_id == hero_id.value
      )[0].hero_name

      const {gender, skin_id} = route.query
      skin_name.value = route.query.skin_name ? route.query.skin_name : curSkinNames.value[0]?.skin_name
      const firstSkin = curSkins.value?.[0]
      curSkin.value = (gender && skin_id) ? `${skin_id}&${gender}` : `${firstSkin?.skin_id}&${firstSkin?.gender}`

      hok_inside_api()
      hok_out_api()
    }

    let route = useRoute(),
      router = useRouter(),
      skin_icon = computed(() => curSkinNames.value.find(item => item.skin_name == skin_name.value)?.icon),
      hero_name = ref(''),
      skin_name = ref(''),
      getSelectedSkinGender = ref(''),
      hero_id = ref(''),
      curSkinNames = computed(() => props.hokIcon?.skin_list?.[hero_id.value] || []),
      curSkin = ref(''),
      skin_id = computed(() => curSkin.value.split('&')[0]),
      curSkinGender = computed(() => {
        return curSkin.value.split('&')[1]
      }),
      curHeroName = computed(() => props.hokIcon?.hero_list.find(item => item.hero_id == hero_id.value)?.hero_name),
      curSkins = computed(() => props.hokIcon?.skin_gender?.[curHeroName.value]?.[skin_name.value] || []),
      genderOptions = ref([]),
      inited = false,
      {in_data, hok_inside_table, mergeCells1, expandCheck, expandCheckAdd, getAdbCount, hok_inside_api} = useInsideTable(skin_id, curSkinGender),
      {hok_out_table, out_data, mergeCells, getActionText, expandCheckOut, expandCheckOutAdd, hok_out_api} = useOutTable(skin_id, curSkinGender)

    watch(() => props.activeTab, val => {
      if (!inited && val == 'demostic-standard') {
        init()
        inited = true
      }
    })
    
    return {
      skin_icon, hero_name, skin_name, getSelectedSkinGender, hero_id, curSkinNames, curSkin, curSkins, genderOptions, onHeroChange, onSkinNameChange, confirm, deleteRow, openBatchGenerateSkins,
      in_data, hok_inside_table, mergeCells1, expandCheck, expandCheckAdd, getAdbCount,
      hok_out_table, out_data, mergeCells, getActionText, expandCheckOut, expandCheckOutAdd,
    }
  }
}
</script>

<style scoped>
.my-table-hok_v1 {
  font-size: 12px;
}

.my-table-hok_v1 /deep/ thead th {
  border-right: 1px solid #606469 !important;
  border-bottom: 1px solid #606469 !important;
}
.my-table-hok_v1 /deep/ .el-table__header tr:first-child th:last-child {
  border-right: none !important;
}

.my-table-hok_v1 /deep/ .el-table--border,
.el-table--group {
  border: 0px;
}
.my-table-hok_v1 /deep/ tbody td {
  border-right: 0px;
}
.my-table-hok_v1 /deep/ .el-table__row {
  background: #42484e;
  color: #fff;
  font-size: 12px;
}
.my-table-hok_v1.el-table /deep/ .el-table__row:hover td {
  background-color: inherit;
  color: #4ed8da;
}
.my-table-hok_v1 /deep/ .el-table__empty-block {
  background: #2d3136;
  color: #fff;
}
.my-table-hok_v1 /deep/ .is-leaf {
  border-bottom: 1px solid #606469 !important;
}
.my-table-hok_v1 /deep/ td {
  border-bottom: 1px solid #606469 !important;
}
.my-table-hok_v1::before {
  height: 0px;
}
</style>